import type { CSSProperties, ReactElement } from "react";

/**
 * Die einzige Dekoration des Produkts: zwei riesige, fast unsichtbare Wolken
 * hinter allem.
 *
 * Sie gehört zum **Rahmen** (ADR-0025) und wird nachgezeichnet, nicht komponiert:
 * `FRAME.md` unter „Ambiente Aura", gebaut in `design/reference/index.html`.
 * Violett bei 72 %/12 %, blau bei 24 %/88 %, `inset: -20%`, hinter allem.
 *
 * Zwei Dinge daran sind leicht zu verlieren:
 *
 * Es sind die **ambienten** Token `--aura-1` / `--aura-2` und nicht das
 * `-login`-Paar. Jenes ist rund fünfmal stärker und sitzt in der Mitte; wer es
 * hier nimmt, bekommt eine Wolkenwand statt eines Hauchs — und wer umgekehrt im
 * Anmeldebild das ambiente Paar nimmt, bekommt eine flach schwarze Fläche.
 *
 * **In der laufenden Anwendung bewegt sie sich nie.** Nur das Anmeldebild atmet
 * (`erpAuraA` / `erpAuraB`). Sie ist trotzdem nicht wegzulassen: `FRAME.md`
 * führt sie unter dem, was nie weggelassen wird, und sie ist der Grund, warum
 * die Werkzeugleiste aus #41 aus Glas ist.
 *
 * Dass man sie **heute nirgends durchscheinen sieht**, ist kein Fehler dieser
 * Datei: Sie liegt hinter dem ganzen Gerüst, und Sidebar, Kopfleiste und
 * Inhaltsfläche sind deckend (`--bg-chrome`, `--bg-app`). So baut es die Vorlage
 * (`reference/index.html`), und so zeigen es die Schirmbilder daneben. Wer sie
 * sichtbar machen will, verschöbe den Rahmen — das ist keine Entscheidung, die
 * in dieser Datei getroffen wird.
 */
export function Aura(): ReactElement {
  return (
    <>
      <div
        style={{
          ...cloud,
          background: "radial-gradient(40% 42% at 72% 12%, var(--aura-1) 0%, var(--aura-1-off) 70%)",
          filter: "var(--blur-aura-1)",
        }}
      />
      <div
        style={{
          ...cloud,
          background: "radial-gradient(34% 36% at 24% 88%, var(--aura-2) 0%, var(--aura-2-off) 68%)",
          filter: "var(--blur-aura-2)",
        }}
      />
    </>
  );
}

/** Was beide Wolken teilen: die Lage hinter allem, und dass sie nichts abfangen. */
const cloud: CSSProperties = {
  position: "absolute",
  inset: "-20%",
  zIndex: 0,
  pointerEvents: "none",
};
